import { motion } from "framer-motion";
import { ArrowRight, Phone, ShieldCheck, BadgeEuro, CalendarCheck } from "lucide-react";
import { COMPANY } from "./data";
import { EASE, scrollToId } from "./scroll";
import { Pic } from "./Pic";
import { Breadcrumbs } from "./Breadcrumbs";

const TRUST = [
  { icon: ShieldCheck, l: "Meisterbetrieb seit 2008" },
  { icon: BadgeEuro, l: "Festpreis-Garantie" },
  { icon: CalendarCheck, l: "Besichtigung in 48 h" },
];

export const SubHero = ({ h1, lead, img, alt, crumbs }) => (
  <section className="relative overflow-hidden bg-ink pb-14 pt-32 sm:pb-20 sm:pt-40" data-testid="sub-hero">
    <Pic name={img} alt={alt} eager sizes="100vw" className="absolute inset-0 h-full w-full object-cover" fetchPriority="high" />
    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/75 to-ink/40" />
    <div className="absolute inset-0 bg-gradient-to-r from-ink/85 via-ink/40 to-transparent" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <Breadcrumbs items={crumbs} />
      <motion.h1 className="max-w-4xl font-display text-[2.6rem] font-bold uppercase leading-[0.95] text-white sm:text-6xl lg:text-7xl" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: EASE }}>
        {h1}
      </motion.h1>
      <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-100 sm:text-lg">{lead}</p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <a href="#angebot" onClick={(e) => { e.preventDefault(); scrollToId("angebot"); }} className="btn-primary btn-mega justify-center" data-testid="sub-hero-offer">Kostenloses Angebot <ArrowRight size={18} className="btn-arrow" /></a>
        <a href={COMPANY.phoneHref} className="btn-ghost btn-mega justify-center bg-white/5 backdrop-blur" data-testid="sub-hero-phone"><Phone size={18} /> {COMPANY.phoneDisplay}</a>
      </div>
      <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-3 border-t border-white/15 pt-6">
        {TRUST.map(({ icon: Icon, l }) => (
          <li key={l} className="flex items-center gap-2.5 text-xs font-bold uppercase tracking-[0.12em] text-white sm:text-sm"><Icon size={20} className="text-terra" /> {l}</li>
        ))}
      </ul>
    </div>
  </section>
);
